import { Navigate, Outlet } from "react-router";
import type { GetApiAuthCapabilitiesResponse } from "@/api/generated/types.gen";
import { Loader } from "@/components/loader";
import { useCapabilities } from "@/hooks/use-capabilities";

type Props = {
  capability: keyof GetApiAuthCapabilitiesResponse;
};

export function ProtectedRoute({ capability }: Props) {
  const { capabilities, isLoading, isError } = useCapabilities();

  if (isLoading) {
    return <Loader />;
  }

  if (isError || !capabilities[capability]) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
